import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=fb221a90"
import script from "./NotificationSetting.vue?vue&type=script&lang=ts"
export * from "./NotificationSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports